export default {
  boost: (locale) => {
    switch (locale) {
      case 'bg':
        return import(/* webpackChunkName: "i18n.common.bg" */'./boost.bg');
      case 'bs':
        return import(/* webpackChunkName: "i18n.common.bs" */'./boost.bs');
      case 'cs':
        return import(/* webpackChunkName: "i18n.common.cs" */'./boost.cs');
      case 'es':
        return import(/* webpackChunkName: "i18n.common.es" */'./boost.es');
      case 'es-MX':
        return import(/* webpackChunkName: "i18n.common.es-MX" */'./boost.es-mx');
      case 'fr':
        return import(/* webpackChunkName: "i18n.common.fr" */'./boost.fr');
      case 'hr':
        return import(/* webpackChunkName: "i18n.common.hr" */'./boost.hr');
      case 'id':
        return import(/* webpackChunkName: "i18n.common.id" */'./boost.id');
      case 'me':
        return import(/* webpackChunkName: "i18n.common.me" */'./boost.me');
      case 'pt':
        return import(/* webpackChunkName: "i18n.common.pt" */'./boost.pt');
      case 'ro':
        return import(/* webpackChunkName: "i18n.common.ro" */'./boost.ro');
      case 'sk':
        return import(/* webpackChunkName: "i18n.common.sk" */'./boost.sk');
      case 'sr-Latn':
        return import(/* webpackChunkName: "i18n.common.sr-Latn" */'./boost.sr-Latn');
      default:
        return import(/* webpackChunkName: "i18n.common" */'./boost');
    }
  },
};
